import AbstractChannel from './AbstractChannel'

export default class AirportParkingReservations extends AbstractChannel {

  name = 'airport_parking_reservations'
  title = 'Airport Parking Reservations'
  titleShort = 'APR'
  color = '#c49c94'

  supportedFeatures = ['blackouts']

}
